// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQNav_container__RGXOw","title":"FAQNav_title__1caFm","itemList":"FAQNav_itemList__2IbTQ","item":"FAQNav_item__3Ztv_","selectedItem":"FAQNav_selectedItem__txfLg"};